import PropTypes from 'prop-types';
import {useCallback} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';

import TargetUserSearchFilterLayout from '../components/TargetUserSearchFilterLayout';
import {useSearchFilters} from '../utils/useSearchFilters';

const TargetUserSearchFilter = ({query}) => {
  // @ts-ignore
  const {setQueryFilters} = useSearchFilters();

  const handleClearClick = useCallback(() => {
    setQueryFilters({
      [SEARCH_FILTERS.USER_ID]: '',
      [SEARCH_FILTERS.FIRST_NAME]: '',
      [SEARCH_FILTERS.LAST_NAME]: '',
    });
  }, []);

  const lastName =
    query[SEARCH_FILTERS.LAST_NAME] === 'undefined'
      ? ''
      : query[SEARCH_FILTERS.LAST_NAME];

  return (
    <TargetUserSearchFilterLayout
      onClearClick={handleClearClick}
      firstName={query[SEARCH_FILTERS.FIRST_NAME]}
      lastName={lastName}
    />
  );
};

TargetUserSearchFilter.propTypes = {
  query: PropTypes.object.isRequired,
};

export default TargetUserSearchFilter;
